export const getEventCoordinates = (
  e: MouseEvent | TouchEvent | React.MouseEvent | React.TouchEvent
) => {
  if ("touches" in e && e.touches && e.touches[0]) {
    return { clientX: e.touches[0].clientX, clientY: e.touches[0].clientY };
  }
  return { clientX: (e as MouseEvent).clientX, clientY: (e as MouseEvent).clientY };
};
